import { once } from "~/jose_modern/once";
import { safeSubmitForm } from "~/jose_modern/auto_submit.js";

export function applyShelfLifeLotCodeState(root, enabled) {
  const valueInput = root.querySelector("#recipe_lot_code_shelf_life_value");
  const unitSelect = root.querySelector("#recipe_lot_code_shelf_life_unit");
  if (!valueInput || !unitSelect) return;

  valueInput.disabled = !enabled;
  unitSelect.disabled = !enabled;
}

const CONTROLS_SELECTOR = '[data-partial="production_runs/lot_code_settings"]';
const pendingSettingsSaves = new Map();
const SHELF_LIFE_INPUT_SELECTOR = [
  "#recipe_lot_code_formula_date_source",
  "#recipe_lot_code_shelf_life_value",
  "#recipe_lot_code_shelf_life_unit",
].join(", ");

function trackSettingsSaves(form) {
  once(form, "lot-code-settings-save-tracker", (trackedForm) => {
    trackedForm.addEventListener("ajax:send", (ev) => {
      const request = ev.detail?.[0];
      if (!request) return;

      let resolve;
      const promise = new Promise((done) => {
        resolve = done;
      });
      pendingSettingsSaves.set(request, { promise, resolve });
    });

    trackedForm.addEventListener("ajax:complete", (ev) => {
      const request = ev.detail?.[0];
      const pendingSave = pendingSettingsSaves.get(request);
      if (!pendingSave) return;

      pendingSave.resolve();
      pendingSettingsSaves.delete(request);
    });
  });
}

async function waitForSettingsSaves() {
  while (pendingSettingsSaves.size) {
    await Promise.all(Array.from(pendingSettingsSaves.values(), ({ promise }) => promise));
  }
}

function initializeCloseAfterSettingsSave(doc) {
  once(doc, "close-after-lot-code-settings-save", (root) => {
    root.addEventListener(
      "submit",
      async (ev) => {
        const form = ev.target.closest("form");
        if (!form?.action.includes("/close") || !pendingSettingsSaves.size) return;

        ev.preventDefault();
        ev.stopImmediatePropagation();
        await waitForSettingsSaves();
        form.requestSubmit();
      },
      true
    );
  });
}

function finishClearedShelfLifeEditing(modal) {
  const editingState = modal.querySelector('[data-keep-shelf-life-editing="true"]');
  if (!editingState) return;

  const container = modal.querySelector(CONTROLS_SELECTOR);
  const dateSource = container.querySelector("#recipe_lot_code_formula_date_source");
  const unitSelect = container.querySelector("#recipe_lot_code_shelf_life_unit");
  if (dateSource) dateSource.value = "0";
  if (unitSelect && editingState.dataset.savedShelfLifeUnit) {
    unitSelect.value = editingState.dataset.savedShelfLifeUnit;
  }
  applyShelfLifeLotCodeState(container, false);
  editingState.removeAttribute("data-keep-shelf-life-editing");
}

export function initializeShelfLifeLotCodeControls(doc = document, submitForm = safeSubmitForm) {
  const container = doc.querySelector(CONTROLS_SELECTOR);
  if (!container) return;

  trackSettingsSaves(container.querySelector("form"));
  initializeCloseAfterSettingsSave(doc);

  const modal = container.closest("#lot-code-formula-modal");
  if (modal) {
    once(modal, "finish-cleared-shelf-life-editing", (trackedModal) => {
      trackedModal.addEventListener("modal:close", () => {
        finishClearedShelfLifeEditing(trackedModal);
      });
    });
    if (!modal.classList.contains("is-active")) finishClearedShelfLifeEditing(modal);
  }

  once(container, "shelf-life-lot-code-controls", (root) => {
    root.addEventListener(
      "change",
      (ev) => {
        const marker = root.querySelector("#recipe_lot_code_shelf_life_update");
        if (marker) marker.value = ev.target.matches(SHELF_LIFE_INPUT_SELECTOR) ? "1" : "0";
        if (!ev.target.matches(SHELF_LIFE_INPUT_SELECTOR)) return;

        const valueInput = root.querySelector("#recipe_lot_code_shelf_life_value");
        if (!valueInput) return;

        if (ev.target.matches("#recipe_lot_code_formula_date_source")) {
          const shelfLifeSelected = ev.target.value === "1";
          applyShelfLifeLotCodeState(root, shelfLifeSelected);

          if (!shelfLifeSelected || valueInput.value) {
            submitForm(ev.target.form);
          } else {
            valueInput.focus();
          }
        } else if (ev.target.matches("#recipe_lot_code_shelf_life_unit") && valueInput.value) {
          submitForm(ev.target.form);
        }
      },
      true
    );
  });
}
